/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Frames_To_Insert_HelpInputs */

const en_frames_to_insert_help = /** @type {(inputs: Frames_To_Insert_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Number of frames to insert between captions`)
};

const fr_frames_to_insert_help = /** @type {(inputs: Frames_To_Insert_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre d’images à insérer entre les sous-titres`)
};

const de_frames_to_insert_help = /** @type {(inputs: Frames_To_Insert_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anzahl der zwischen den Untertiteln einzufügenden Frames`)
};

const it_frames_to_insert_help = /** @type {(inputs: Frames_To_Insert_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numero di fotogrammi da inserire tra le didascalie`)
};

const ru_frames_to_insert_help = /** @type {(inputs: Frames_To_Insert_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Количество кадров для вставки между подписями`)
};

const es_frames_to_insert_help = /** @type {(inputs: Frames_To_Insert_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Número de fotogramas a insertar entre subtítulos`)
};

const zh_cn2_frames_to_insert_help = /** @type {(inputs: Frames_To_Insert_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字幕之间要插入的帧数`)
};

const ja_frames_to_insert_help = /** @type {(inputs: Frames_To_Insert_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キャプション間に挿入するフレームの数`)
};

const hi_frames_to_insert_help = /** @type {(inputs: Frames_To_Insert_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कैप्शन के बीच में डालने के लिए फ़्रेमों की संख्या`)
};

const pt_pt2_frames_to_insert_help = /** @type {(inputs: Frames_To_Insert_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Número de quadros a inserir entre as legendas`)
};

/**
* | output |
* | --- |
* | "Number of frames to insert between captions" |
*
* @param {Frames_To_Insert_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const frames_to_insert_help = /** @type {((inputs?: Frames_To_Insert_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Frames_To_Insert_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_frames_to_insert_help(inputs)
	if (locale === "de") return de_frames_to_insert_help(inputs)
	if (locale === "it") return it_frames_to_insert_help(inputs)
	if (locale === "ru") return ru_frames_to_insert_help(inputs)
	if (locale === "es") return es_frames_to_insert_help(inputs)
	if (locale === "zh-CN") return zh_cn2_frames_to_insert_help(inputs)
	if (locale === "ja") return ja_frames_to_insert_help(inputs)
	if (locale === "hi") return hi_frames_to_insert_help(inputs)
	if (locale === "pt-PT") return pt_pt2_frames_to_insert_help(inputs)
	return en_frames_to_insert_help(inputs)
});